import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-sections" }
const _hoisted_2 = { class: "application-form" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fields" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-minus" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "buttons" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_13 = ["textContent"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "application-mode-form" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Features", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-minus" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

import { computed, markRaw, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions } from "@/store";
import { Application, applicationValidations } from "@/models/application";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import { useLoading } from "../common/loading.composable";
import FieldItems from "../common/FieldItems.vue";
import { useRoute } from "vue-router";
import { Note } from "@/models/note";
import { useEvents, Event } from "@/core/services/events.composable";
import { DrawerMutations } from "@/stores/drawer.store";
import AddNoteForm from "../note/AddNoteForm.vue";
import { router } from "@/router";
import FieldLong from "../common/FieldLong.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const events = useEvents();

const note = computed<Note>(() => store.state.note);
const notes = computed<Note[]>(() => store.state.notes);

const application = reactive<Application>({
  ...store.state.application
});

onMounted(() => {
  if (!route.params.id) {
    store.dispatch(Actions.NewApplication);
    Object.assign(application, { ...store.state.application });
  }
  store.dispatch(Actions.GetNotes);
});

const isNew = computed<boolean>(() => application.id === -1);
const { loading, setLoading } = useLoading();

const $v = useVuelidate(applicationValidations, { application });
const emit = __emit;

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreApplication, application);

    setLoading(false);
    cancel();
  }
};

const cancel = () => {
  emit("close");

  if (application.id !== -1) {
    router.push(`/application/${application.id}`);
  } else {
    router.push(`/application`);
  }
};

const addMode = () => {
  application.modes = [...(application.modes || []), ""];
};

const removeMode = (index: number) => {
  application.modes.splice(index, 1);
};

const addNote = () => {
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(AddNoteForm),
    data: {
      notes: notes.value.filter(
        (s) => !(application.features || []).includes(s.id)
      )
    }
  });
};

events.on(Event.NoteCreated, () => {
  application.features = [...(application.features || []), note.value.id];
});

const removeNote = (index: number) => {
  application.features.splice(index, 1);
};

const getNote = (id: number): string => {
  return notes.value.find((s) => s.id === id)?.title || "unknown";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      application
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _withModifiers(submit, ["prevent"]),
            class: _normalizeClass({ submitting: _unref(loading) })
          }, [
            _createElementVNode("h2", {
              textContent: _toDisplayString(isNew.value ? 'Add application' : 'Edit application')
            }, null, 8, _hoisted_3),
            (isNew.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Fill out the details of the application"))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "Edit the details of the application")),
            _createVNode(Field, {
              label: "Name",
              validation: _unref($v).application.name,
              modelValue: application.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((application.name) = $event))
            }, null, 8, ["validation", "modelValue"]),
            _createVNode(FieldLong, {
              label: "Description",
              validation: _unref($v).application.description,
              modelValue: application.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((application.description) = $event))
            }, null, 8, ["validation", "modelValue"]),
            _createVNode(Field, {
              label: "Website",
              validation: _unref($v).application.website,
              modelValue: application.website,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((application.website) = $event))
            }, null, 8, ["validation", "modelValue"]),
            _createVNode(FieldItems, {
              label: "Modes",
              onAddItem: addMode
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(application.modes, (_, index) => {
                    return (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createVNode(Field, {
                        placeholder: "Name",
                        class: "block",
                        modelValue: application.modes[index],
                        "onUpdate:modelValue": ($event: any) => ((application.modes[index]) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn icononly",
                        onClick: ($event: any) => (removeMode(index))
                      }, _hoisted_9, 8, _hoisted_7)
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "confirm",
                type: "button",
                disabled: _unref(loading),
                onClick: submit
              }, [
                _hoisted_12,
                _createElementVNode("span", {
                  class: "text",
                  textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
                }, null, 8, _hoisted_13)
              ], 8, _hoisted_11),
              _createElementVNode("button", {
                class: "cancel",
                type: "button",
                onClick: cancel
              }, _hoisted_15),
              (_unref(loading))
                ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ], 34))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("form", null, [
        _hoisted_17,
        _createVNode(FieldItems, {
          label: "Features",
          onAddItem: addNote
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(application.features, (note, index) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createTextVNode(_toDisplayString(getNote(note)) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn icononly",
                    onClick: ($event: any) => (removeNote(index))
                  }, _hoisted_20, 8, _hoisted_18)
                ]))
              }), 256))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})